module.exports = __webpack_public_path__ + "static/media/FanSaves-Banner-2022.ae494601.jpg";